export default "__VITE_ASSET__e9d1b086__"